import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import SearchIcon from '@mui/icons-material/Search';
import { Box } from '@mui/material';

import { SCUILoadingLinear } from '../../../atomic/atoms';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import { SCUIContent } from '../../../atomic/organisms';
import SummaryAggregationQuery from '../../../services/query/summaryAggregation/SummaryAggregationQuery.services';
import { PageUrl } from '../../../types/enums/pageUrl-enums';

import { SummaryDetailSearchList } from './components';
import { SDS } from './summaryDetailSearch.classes';

export const SaSummaryDetailSearch = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [orderNumber, setOrderNumber] = useState<string>('');
    const [rows, setRows] = useState<any[]>([]);
    const [isSearched, setIsSearched] = useState<boolean>(false);

    const { t } = useTranslation();

    const handleSearch = () => {
        const trimmedOrderNumber = orderNumber.trim();
        if (!trimmedOrderNumber) return;

        setIsLoading(true);
        setIsSearched(true);

        SummaryAggregationQuery.FetchOrderSummaryDetail({
            orderNumber: trimmedOrderNumber,
        })
            .then((res: any) => {
                const details = (res?.summaryItemDetails || []).map((item: any, index: number) => ({
                    ...item,
                    id: item?.summaryItemDetailId ?? index,
                    orderNumber: res?.orderNumber ?? trimmedOrderNumber,
                    orderDate: res?.orderDate,
                }));
                setRows(details);
                setIsLoading(false);
            })
            .catch(() => {
                Swal.fire(t('general.anErrorOccured'), '', 'error');
                setRows([]);
                setIsLoading(false);
            });
    };

    return (
        <SCUIContent className={SDS.page}>
            <Box className={SDS.root}>
                <Box
                    className={SDS.breadcrumb}
                    sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                >
                    <SearchIcon className={SDS.titleIcon} color="primary" fontSize="large" />
                    <SCUIBreadCrumb
                        onlyTitle={t('summaryAggregation.summaryDetailSearch.title')}
                        components={[
                            {
                                title: t('summaryAggregation.summaryDetailSearch.title'),
                                link: PageUrl.summaryAggregation.summaryDetailSearch.url,
                            },
                        ]}
                    />
                </Box>
                {isLoading && (
                    <Box sx={{ margin: '24px 0' }} className={SDS.loading}>
                        <SCUILoadingLinear display={isLoading} />
                    </Box>
                )}
                <SummaryDetailSearchList
                    rows={rows}
                    orderNumber={orderNumber}
                    setOrderNumber={setOrderNumber}
                    handleSearch={handleSearch}
                    isSearched={isSearched}
                />
            </Box>
        </SCUIContent>
    );
};
